import * as types from "../../actions/actionTypes";
const sumObj = {
  payment: 0,
  receive: 0,
  remain: 0
};
const initialData = {
  data: {
    data: []
  },
  page_sum: sumObj,
  total_sum: sumObj,
  remain_sum: sumObj,
  use_remain: false
};
const initialState = {
  loading: false,
  data: initialData,
  error: ""
};

const ManagerAccountReview = (state = initialState, action) => {
  switch (action.type) {
    case types.MANAGER_GET_ACCOUNT_REVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        data: action.pageNumber ? state.data : initialData,
        error: ""
      };
    case types.MANAGER_GET_ACCOUNT_REVIEW_SUCCESS:
      return { ...state, data: action.payLoad, loading: false };
    case types.MANAGER_GET_ACCOUNT_REVIEW_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST:
      return { ...state, processing: true };
    case types.MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_SUCCESS:
      return { ...state, processing: false };
    case types.MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_FAILURE:
      return { ...state, processing: false };

    default:
      return state;
  }
};

export default ManagerAccountReview;
